(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    window.addEventListener('resize', function() {
    if (window.innerWidth <= 768) {
      // Show the mobile image and hide the default image
      document.querySelectorAll('.mobile-slide__image').forEach(function(img) {
        img.style.display = 'block';
      });
      document.querySelectorAll('.slide__image').forEach(function(img) {
        img.style.display = 'none';
      });
    } else {
      // Show the default image and hide the mobile image
      document.querySelectorAll('.mobile-slide__image').forEach(function(img) {
        img.style.display = 'none';
      });
      document.querySelectorAll('.slide__image').forEach(function(img) {
        img.style.display = 'block';
      });
    }
  });

  // Trigger resize event on page load to set the initial state
  window.dispatchEvent(new Event('resize'));
  } catch(e) { console.error(e); }
})();

})();
